import React, { useCallback, useState } from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import NutrorForm from '../../Form/Nutror';

interface IProps {
  nutror: any;
  index: any;
  onEdit?: any;
  productId?: number;
  onRemove: any;
}

const Nutror: React.FC<IProps> = ({ nutror, index, onEdit, onRemove }) => {
  const [modal, setModal] = useState(false);

  const openModal = useCallback(() => {
    setModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setModal(false);
  }, []);

  const onOk = useCallback(
    (newItem: any, old: any) => {
      setModal(false);
      if (onEdit) onEdit(newItem, old);
    },
    [onEdit]
  );

  return (
    <>
      <li
        className='flex cursor-pointer items-center gap-3 border-b border-gray-200 px-4 py-2 hover:bg-gray-50'
        onClick={openModal}
      >
        <img src='/img/nutror-symbol.svg' width='28' />
        <div className='flex-1'>
          <div className='font-medium'>{`${nutror.type === 'C' ? 'Curso' : 'Pacote'} via Nutror`}</div>
          <div className='text-sm text-gray-500'>{nutror.nutror_name}</div>
        </div>
        <Button
          type='text'
          icon={<DeleteOutlined style={{ fontSize: 18 }} />}
          onClick={e => {
            e.stopPropagation();
            onRemove(nutror.nutror_name, index);
          }}
        />
      </li>
      {modal && <NutrorForm nutror={nutror} isModal={true} open={modal} onClose={closeModal} onOk={onOk} />}
    </>
  );
};

export default Nutror;
